export default {
  SET_RANKLIST: (state, payload) => (state.ranklist = payload),
};
